export function DemoNotice() {
  return (
    <aside className="demo-notice" aria-label="Demo mode">
      <strong>Demo mode</strong>
      <span>Use test information only. Demo data may be reset.</span>
    </aside>
  );
}
